// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ViewOff: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 51 38" enableBackground="new 0 0 51 38" xmlSpace="preserve">
<g>
	<rect x="25.26" y="-5.77" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -5.7612 24.5515)" width="3" height="50"/>
	<path d="M25.5,30.22c-9.04,0-17.29-4.48-22.19-11.72c2.4-3.54,5.6-6.42,9.3-8.44l-2.04-2.04c-4.2,2.45-7.77,5.92-10.34,10.16
		l-0.08,0.13L0,18.41l0.05,0.09L0,18.59l0.16,0.1l0.3,0.49C5.78,27.68,15.18,33,25.5,33c3.02,0,5.96-0.45,8.74-1.31l-2.26-2.26
		C29.9,29.95,27.72,30.22,25.5,30.22z"/>
	<path d="M16.86,14.31c-0.65,1.26-1.01,2.69-1.01,4.19c0,5.23,4.39,9.46,9.78,9.46c1.44,0,2.8-0.3,4.03-0.84l-2.04-2.04
		c-0.63,0.17-1.3,0.27-2,0.27c-3.97,0-7.17-3.07-7.17-6.85c0-0.77,0.13-1.52,0.38-2.21L16.86,14.31z"/>
	<path d="M51,18.41l-0.16-0.1l-0.29-0.49C45.22,9.32,35.82,4,25.5,4c-2.74,0-5.41,0.37-7.97,1.08l2.29,2.3
		c1.84-0.39,3.74-0.6,5.67-0.6c9.04,0,17.29,4.48,22.19,11.72c-2.26,3.33-5.23,6.08-8.66,8.08l2.02,2.02
		c3.93-2.42,7.27-5.76,9.71-9.79l0.08-0.13L51,18.59l-0.05-0.09L51,18.41z"/>
	<path d="M34.64,22.19c0.5-1.13,0.77-2.38,0.77-3.69c0-5.23-4.39-9.46-9.78-9.46c-1.24,0-2.42,0.22-3.51,0.63l2.11,2.11
		c0.45-0.09,0.92-0.13,1.4-0.13c3.97,0,7.17,3.07,7.17,6.85c0,0.57-0.07,1.12-0.21,1.65L34.64,22.19z"/>
</g>
</svg>;
};

export default React.memo(ViewOff);
